// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"b0ad077b","253":"993d74b7","304":"297dcbdd","488":"8fc50606","624":"4241bc13","663":"277898a6","670":"b69fe1ca","738":"4346f0f1","813":"34114685","880":"77229bd5","976":"e8ed40cb"}[chunkId] + ".chunk.js";
};